export default __webpack_public_path__ + "static/media/grafema_SET_21.457ca2bf.jpg";